<template lang="pug">
.form-charge
  h2 {{contract_id?'':'空房'}}乐住智能电表充值

  .ui.two.columns.stackable.grid.form
    .column
      .actions
        .ui.button.orange(@click='form.fee = 100') 电100元
        .ui.button.yellow(@click='form.fee = 50') 电50元

      .ui.two.fields
        .ui.field
          label 电表编号
          el-input(v-model='form.meter_id', :allow-dot='false', disabled)
        .ui.field
          label 电费 / 元
          compare-input(v-model='form.fee', :min='0', :allow-dot='true')
      .ui.two.fields
        .ui.field
          label 支付方式
          payment-method-select(v-model='form.payment_method')

        .ui.field
          label 备注
          el-input(v-model='form.note')

    .column
      receipts.ui.segment(v-show='receipts && receipts.length', :receipts='receipts')

    .ui.field.actions
      .ui.button.themed.icon.labeled(@click='finish()', :class='{disabled:!submitable}')
        i.icon.checkmark
        | 充值
      .ui.button(@click='cancel') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { AutoTable } from '../auto'
import { Receipts, PaymentMethodSelect, CompareInput } from '../basic'

export default {
  name: 'form-charge',
  props: ['no', 'contract_id'],
  components: {
    AutoTable,
    Receipts,
    PaymentMethodSelect,
    CompareInput,
  },
  data() {
    return {
      form: {
        meter_id: null,
        fee: 0,
        note: '',
        payment_method: 'cash',
      },
      dialog_charging: false,
    }
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    contract() {
      if (this.contract_id)
        return this.$store.getters.contract(this.contract_id)
      return null
    },
    customers() {
      if (this.contract)
        return this.$store.getters.customers_filter(this.contract._customers)
      return []
    },
    submitable() {
      if (this.form.fee > 0 && this.form.meter_id)
        return true
      return false
    },
    receipts() {
      const receipts = []

      if (this.form.fee) {
        receipts.push({
          name: '电费',
          quantity: this.form.fee,
          unit_price: 1,
        })
      }

      return receipts
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (!this.contract_id)
        this.form.note = '空房水电充值'
      this.form.meter_id = this.room.lezhu_meter_id
    },
    print_charge() {
      this.$templater.request('charge', {
        room: this.room,
        contract: this.contract,
        utilities: [{ type: 'electricity', quantity: this.form.fee, unit_price: 1 }],
        note: this.form.note,
        payment_method: this.form.payment_method,
        customers: this.customers,
        $methods: this.$store.state.summary.payment_methods,
      })
    },
    finish() {
      if (this.submitable) 
        this.sumbit_form()
    },
    sumbit_form: MakeForm({
      type: 'post',
      url: 'charges/lezhu',
      confirm: (confirm) => (confirm === false ? null : '确定进行充值？'),
      payload() {
        return {
          _room: this.room._id,
          _contract: this.contract ? this.contract._id : null,
          ...this.form,
        }
      },
      $afterSuccess() {
        this.print_charge()
        this.$router.back()
      },
    }),
    cancel() {
      this.$router.back()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormChargeLezhu.vue?6f11d8d4